class Accordion {
    constructor() {
        this.InitAccordion();
    }

    InitAccordion() {
        const accordionButtons = document.querySelectorAll(
            ".js-accordion-button",
        );
        if (accordionButtons.length === 0) {
            return;
        }

        accordionButtons.forEach((accordionButton) => {
            accordionButton.addEventListener("click", function (e) {
                const button = e.target as HTMLButtonElement;
                if (button.getAttribute("aria-expanded") === "true") {
                    button.setAttribute("aria-expanded", "false");
                    button.setAttribute(
                        "aria-label",
                        button.getAttribute("data-open") || "",
                    );
                } else {
                    button.setAttribute("aria-expanded", "true");
                    button.setAttribute(
                        "aria-label",
                        button.getAttribute("data-close") || "",
                    );
                }
                const parentItem = button?.parentElement?.parentElement;
                if (parentItem) {
                    parentItem.classList.toggle("accordion-item-block--open");
                    parentItem.classList.toggle("accordion-item-block--close");
                }
            });
        });
    }
}

export default Accordion;
